import { combineReducers } from "redux";
import customersList from "./customer/customerSlice";

const rootReducer = combineReducers({ customersList: customersList });

export default rootReducer;
